import Vue from 'vue';

export function flush(state) {
  state.products = [];
  state.drinks = [];
  state.deliveryMethod = null;
  state.paymentMethod = null;
  state.coupon = null;
  state.totalPrice = 0;
  state.totalDiscount = 0;
  state.previousOrder = null;
}

export function addProduct(state, { product }) {
  state.products.push(product);
}

export function addDrink(state, product) {
  state.drinks.push(product);
}

export function removeDrink(state, product) {
  const productIndex = state.drinks.findIndex((i) => i.uid === product.uid);
  if (productIndex > 0) {
    state.drinks.splice(productIndex, 1);
  }
  else {
    state.drinks.splice(product, 1);
  }
}

export function flushDrinks(state) {
  state.drinks = [];
}

export function updateProduct(state, { product }) {
  Vue.set(
    state.products,
    state.products.findIndex((p) => p.uid === product.uid),
    product,
  );
}

export function updateDrink(state, { product }) {
  state.drinks.forEach((drink) => {
    if (drink.id === product.id) {
      drink.options = product.options;
    }
  });
}

export function updateDrinkOptions(state, { product, ice }) {
  product.options.forEach((option) => {
    option.groups.forEach((group) => {
      group.values.forEach((value) => {
        value.selected = ice ? 1 : 0;
      });
    });
  });
}

export function removeProduct(state, { product }) {
  state.products.splice(product, 1);
}

export function updateProductQuantity(state, { uid, quantity }) {
  state.products.find((entry) => entry.uid === uid).quantity = quantity;
}

export function updateDeliveryMethod(state, { deliveryMethod }) {
  state.deliveryMethod = deliveryMethod;
}

export function updatePaymentMethod(state, { paymentMethod }) {
  state.paymentMethod = paymentMethod;
}

export function updateTotalPrice(state, { totalPrice }) {
  state.totalPrice = totalPrice;
}

export function updateTotalDiscount(state, { totalDiscount }) {
  state.totalDiscount = totalDiscount;
}

export function updatePreviousOrder(state, { previousOrder }) {
  state.previousOrder = previousOrder;
}

export function updateLocation(state, { location }) {
  state.location = location;
}
